import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RosterService {

  constructor() { }

  getPGY(currentDate: Date, endDate: Date) {
    let yearDifference = endDate.getFullYear() - currentDate.getFullYear();

    // Adjust for scenario where there is less than one year remaining.
    if (yearDifference === 1) {
      if (currentDate.getMonth() > endDate.getMonth()) {
        yearDifference = 0;
      } else if (currentDate.getMonth() === endDate.getMonth()
        && currentDate.getDay() > endDate.getDay()) {
          yearDifference = 0;
      }
    }

    let returnValue = 5 - (yearDifference);

    // Adjust for edge case where current year and end year are the same.
    if (returnValue === 0) {
      returnValue = 1;
    }

    // Adjust for edge case when current year is more than 5 years before end year.
    if (returnValue < 0) {
      returnValue = 1;
    }

    // Adjust for edge case where current year is after end year.
    if (returnValue > 5) {
      returnValue = 5;
    }
    return returnValue;
  }

  isValidEndDate(startDate: Date, endDate: Date): string[] {
    const endDateReasons = [];
    if (startDate > endDate) {
      endDateReasons.push('Start Date must be before End Date');
    }

    if (!endDate) {
      endDateReasons.push('End Date is required');
    }

    if (endDate.getMonth() !== 5 || endDate.getDate() !== 30) {
      endDateReasons.push('End Date must be June 30');
    }

    return endDateReasons;
  }

  isValidStartDate(startDate: Date, endDate: Date): string[] {
    const startDateReasons = [];
    if (startDate > endDate) {
      startDateReasons.push('Start Date must be before End Date');
    }

    if (!startDate) {
      startDateReasons.push('Start Date is required');
    }

    if (startDate.getMonth() !== 6 || startDate.getDate() !== 1) {
      startDateReasons.push('Start Date must be July 1');
    }

    return startDateReasons;
  }

}
